import React from 'react';
import { AlertCircleIcon } from 'src/components/Icons';

import StandardPage from 'src/components/UI/StandardPage';

const params = {
  title: 'Page disabled!',
  topIcon: <AlertCircleIcon />,
  desc:
    'The page you’re trying to reach has been disabled by the Portal owner, please get in touch if this is a mistake.',
};

export const NotAllowedPage: React.FC = () => <StandardPage {...params} />;
